import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import UserDetailsDrawer from './UserDetailsDrawer';




const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  
  const [selectedUser, setSelectedUser] = useState(null);
const [drawerOpen, setDrawerOpen] = useState(false);
const [statusFilter, setStatusFilter] = useState('');
const [planFilter, setPlanFilter] = useState('');
const filteredUsers = users.filter(user => {
    return (
      (!statusFilter || user.status === statusFilter) &&
      (!planFilter || user.plan === planFilter)
    );
  });
  
  const exportToCSV = () => {
    const headers = ['Name', 'Email', 'Plan', 'Country', 'phone', 'company', 'Status', 'Created On'];
    const rows = filteredUsers.map(user => [
      user.name || '-',
      user.email,
      user.plan || 'free',
      user.country || '-',
      user.phone,
      user.company,
      user.status,
      new Date(user.createdAt).toLocaleDateString()
    ]);
  
    const csvContent =
      'data:text/csv;charset=utf-8,' +
      [headers, ...rows].map(e => e.join(',')).join('\n');
  
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'user_list.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await fetch(`http://localhost:5003/admin/users?search=${search}`);
      const data = await res.json();
      setUsers(data);
      
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  };

  const handleSearchChange = e => {
    setSearch(e.target.value);
  };

  

  

  const handleSearchSubmit = e => {
    e.preventDefault();
    fetchUsers();
  };

  return (
    
      <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
  {/* Left: Filters and Search */}
  <div className="flex flex-wrap gap-2 items-center">
    {/* Status Filter */}
    <select
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
      className="border px-3 py-2 rounded text-sm"
    >
      <option value="">All Statuses</option>
      <option value="active">Active</option>
      <option value="suspended">Suspended</option>
    </select>

    {/* Plan Filter */}
    <select
      value={planFilter}
      onChange={(e) => setPlanFilter(e.target.value)}
      className="border px-3 py-2 rounded text-sm"
    >
      <option value="">All Plans</option>
      <option value="free">Free</option>
      <option value="pro">Pro</option>
      <option value="premium">Premium</option>
    </select>

    {/* Search Input */}
    <form onSubmit={handleSearchSubmit} className="flex gap-2">
      <input
        type="text"
        value={search}
        onChange={handleSearchChange}
        placeholder="Search by name or email"
        className="border rounded-md px-3 py-2 text-sm"
      />
      <button
        type="submit"
        className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm"
      >
        Search
      </button>
    </form>
  </div>

  {/* Right: Export Button */}
  <button
    onClick={exportToCSV}
    className="bg-green-600 text-white px-4 py-2 rounded-md text-sm hover:bg-green-700"
  >
    Export CSV
  </button>
</div>


        <div className="overflow-auto rounded-lg shadow border">
        

          <table className="min-w-full bg-white text-sm">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="px-4 py-3 font-medium font-semibold">Name</th>
                <th className="px-4 py-3 font-medium font-semibold">Email</th>
                <th className="px-4 py-3 font-medium font-semibold">Plan</th>
                <th className="px-4 py-3 font-medium font-semibold">Country</th>
                <th className="px-4 py-3 font-medium font-semibold">Status</th>
                <th className="px-4 py-3 font-medium font-semibold">Created On</th>
                <th className="px-4 py-3 font-medium font-semibold">Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map(user => (
                <tr key={user._id} className="border-t">
                  <td className="px-4 py-2">{user.name || '-'}</td>
                  <td className="px-4 py-2">{user.email}</td>
                  <td className="px-4 py-2">{user.plan || 'Free'}</td>
                  <td className="px-4 py-2">{user.country || '-'}</td>
                  <td className="px-4 py-2"><span
    className={`px-2 py-1 rounded-full text-xs font-medium ${
      user.status === 'active'
        ? 'bg-green-100 text-green-700'
        : user.status === 'suspended'
        ? 'bg-yellow-100 text-yellow-800'
        : 'bg-gray-100 text-gray-600'
    }`}
  >
    {user.status}
  </span></td>
                  <td className="px-4 py-2">{new Date(user.createdAt).toLocaleDateString()}</td>
                  <td className="px-4 py-2"> <button
  className="text-blue-600 hover:underline text-sm"
  onClick={() => {
    setSelectedUser(user);
    setDrawerOpen(true);
  }}
>
  View
</button></td>

                </tr>
              ))}
              {users.length === 0 && (
                <tr>
                  <td className="px-4 py-6 text-center text-gray-500" colSpan="5">
                    No users found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <UserDetailsDrawer
  isOpen={drawerOpen}
  onClose={() => setDrawerOpen(false)}
  user={selectedUser}
  onUserUpdated={fetchUsers}
/>


        </div>
      </div>
    
  );
};




export default UserManagement;
